export const PRIMARY_LANGUAGE_CODE = 'ru';

/**
 * Языки, на которые переводятся сущности сайта.
 * Русский — основной: хранится в полях самой сущности, остальные — в её localizations.
 */
export const LOCALIZATION_LANGUAGES = [
  { code: 'EN', title: 'Английский', native: 'English' },
  { code: 'KK', title: 'Казахский', native: 'Қазақша' },
  { code: 'KY', title: 'Кыргызский', native: 'Кыргызча' },
  { code: 'MN', title: 'Монгольский', native: 'Монгол' },
  { code: 'UZ', title: 'Узбекский', native: 'Oʻzbekcha' },
];

export const getLanguageByCode = (code) =>
  LOCALIZATION_LANGUAGES.find((i) => i.code === String(code || '').toUpperCase());
